import { useTranslation } from "react-i18next";

import { Alert, Button, Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import {
  FaShieldAlt,
  FaRobot,
  FaLock,
  FaCloudUploadAlt,
  FaEnvelope,
  FaGoogle,
  FaForward,
  FaCog,
  FaMagic,
  FaMicrosoft,
  FaApple,
  FaYahoo,
} from "react-icons/fa";
import { useContext } from "react";
import AppContext from "../context/app-context";
export default function EmailSetUpComp() {
  const { userProfile, trackingItems = [] } = useContext(AppContext);

  const { userId = "id" } = userProfile || {};
  const { t } = useTranslation();
  return (
    <div id="email-setup">
      <Card className="shadow-lg mb-5 border-0" style={{ borderRadius: "15px", backgroundColor: "#f8f9fa" }}>
        <Card.Body className="p-5">
          <Row className="align-items-center mb-4">
            <Col md={8}>
              <h2 className="display-6 mb-3">
                <FaEnvelope className="text-primary me-2" />
                {t("emailSetup.title")}
              </h2>
              <p className="lead text-muted">{t("emailSetup.subtitle")}</p>
            </Col>
          </Row>

          <Row className="g-4">
            <Col md={6}>
              <div className="p-4 bg-white rounded-3 h-100 shadow-sm">
                <div className="d-flex align-items-center mb-3">
                  <div className="step-badge bg-primary text-white me-3">1</div>
                  <h4 className="mb-0">{t("emailSetup.step1Title")}</h4>
                </div>
                <p className="text-muted">{t("emailSetup.step1Desc")}</p>
                <div className="email-example mt-4 p-3 bg-light rounded">
                  <code>receipt+{userId}@kokofin.com</code>
                </div>
              </div>
            </Col>

            <Col md={6}>
              <div className="p-4 bg-white rounded-3 h-100 shadow-sm">
                <div className="d-flex align-items-center mb-3">
                  <div className="step-badge bg-success text-white me-3">2</div>
                  <h4 className="mb-0">{t("emailSetup.step2Title")}</h4>
                </div>
                <p className="text-muted">{t("emailSetup.step2Desc")}</p>
                <div className="mt-4">
                  <FaRobot className="text-info me-2" size={24} />
                  <FaForward className="text-warning me-2" size={24} />
                  <FaCog className="text-danger" size={24} />
                </div>
              </div>
            </Col>
          </Row>
          {/* Advanced Setup */}
          {/* <div className="mt-5 pt-4 border-top">
            <h4 className="mb-4">
              <FaMagic className="text-purple me-2" />
              {t("emailSetup.autoForwardTitle")}
            </h4>

            <Row className="g-4">
              <Col lg={3} md={6}>
                <a
                  href="https://support.google.com/mail/answer/6579?hl=en"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  <div className="text-center p-3 hover-effect h-100">
                    <FaGoogle className="text-primary mb-3" size={40} />
                    <h5>Gmail</h5>
                    <small className="text-muted d-block">{t("emailSetup.gmailGuide")}</small>
                  </div>
                </a>
              </Col>

              <Col lg={3} md={6}>
                <a
                  href="https://support.microsoft.com/en-us/office/set-up-rules-in-outlook-75ab719a-2ce8-49a7-a214-6d62b67cbd41"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  <div className="text-center p-3 hover-effect h-100">
                    <FaMicrosoft className="text-primary mb-3" size={40} />
                    <h5>Outlook</h5>
                    <small className="text-muted d-block">{t("emailSetup.outlookGuide")}</small>
                  </div>
                </a>
              </Col>

              <Col lg={3} md={6}>
                <a
                  href="https://support.apple.com/en-ca/guide/icloud/mm6b1a3960/icloud"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  <div className="text-center p-3 hover-effect h-100">
                    <FaApple className="text-dark mb-3" size={40} />
                    <h5>Apple Mail</h5>
                    <small className="text-muted d-block">{t("emailSetup.appleGuide")}</small>
                  </div>
                </a>
              </Col>

              <Col lg={3} md={6}>
                <a
                  href="https://clean.email/blog/email-management/yahoo-mail-forwarding"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-decoration-none"
                >
                  <div className="text-center p-3 hover-effect h-100">
                    <FaYahoo className="text-purple mb-3" size={40} />
                    <h5>Yahoo Mail</h5>
                    <small className="text-muted d-block">{t("emailSetup.yahooGuide")}</small>
                  </div>
                </a>
              </Col>
            </Row>
          </div> */}
        </Card.Body>
      </Card>
    </div>
  );
}
